import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { translateComponent } from "../../utils/services/translate";
import useAuth from "../../hooks/useAuth";

// CSS
import "./Navigation.scss";

// Actions
import { setShowNavigationMenu } from "../../redux/actions";

const Navigation = () => {
  const { isAuthed, logout, phoneNumber } = useAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const show_navigation = useSelector((state) => state.Layout.show_navigation);
  const disable_navigation = useSelector((state) => state.Layout.disable_navigation);
  const language = useSelector((state) => state.Layout.language);
  const translations = useSelector((state) => state.Layout.translations);

  const handleNavigationClose = () => {
    dispatch(setShowNavigationMenu(false));
  };

  const handleLogout = () => {
    handleNavigationClose();
    logout();
  };

  if (!show_navigation || disable_navigation || !isAuthed()) {
    return null;
  }

  return (
    <div className="navigation min-height-100">
      <div className="menu-container pl-4">
        <div className="menu-container-content d-flex flex-column h-100">
          <div className="list-menu pt-3 flex-grow-1">
            <div className="m-4 bg-green text-white p-5">
              <h3 className="text-xl p-2 text-extra-bold text-white d-inline">
                AdminWeb
              </h3>
              <span className="text-m text-white float-end">
                ({phoneNumber()})
              </span>
            </div>
          </div>

          <div className="list-item m-5 pb-5 mt-auto">
            <button
              className="btn btn-danger w-100 text-lg"
              onClick={handleLogout}
            >
              {translateComponent(
                translations,
                language,
                "navigationMenu",
                "logoutButton"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navigation;
